import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../store";

export interface LiteralsConfigurationState {
  configurations: any;
}

const initialState: LiteralsConfigurationState = {
  configurations: { current_route_literals: {} },
};

export const literalsConfigurationSlice = createSlice({
  name: "literalsConfiguration",
  initialState: initialState,
  reducers: {
    setConfiguration: (state, action) => {
      const { configuration } = action.payload;
      state.configurations = {
        ...state.configurations,
        ...configuration,
      };
    },
  },
});

const { setConfiguration } = literalsConfigurationSlice.actions;

export const _setLiteralsConfiguration =
  (configuration: any): AppThunk =>
  (dispatch) => {
    dispatch(setConfiguration({ configuration }));
  };

export default literalsConfigurationSlice.reducer;
